// ComponentManager.tsx
import { Box, Typography } from "@mui/material";
import UpdateFooter from "./UpdateFooter";

const ComponentManager = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Component Assignment Manager
      </Typography>

      {/* Form to update component leads */}
      <UpdateFooter />
    </Box>
  );
};

export default ComponentManager;
